import {
  ROW_LENGTH,
  PLAYER_1,
  PLAYER_2,
  JUMP,
  SOLID
} from '@game/constants'

function clone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

let context = {}

export function setContext (board) {
  context = board
}

export function movePomTo (i, ai, move, from) {
  const board = context

  let origin
  let dojump

  if (ai) {
    origin = from
    dojump = move === JUMP
  } else {
    origin = board.selected
    dojump = board.jumpHash[i]
  }

  board.poms[i] = board.whoseTurn
  if (dojump) {
    board.poms[origin] = SOLID
  }

  const n = i
  const x = n % ROW_LENGTH
  const y = Math.floor(n / ROW_LENGTH)

  let oddy = 0
  if (y % 2 === 1) {
    oddy = 1
  }

  const who = board.whoseTurn
  const res = []

  res.push(stealPom(x - 1, y, who))
  res.push(stealPom(x + 1, y, who))

  res.push(stealPom(x - 1 + oddy, y - 1, who))
  res.push(stealPom(x + oddy, y - 1, who))

  res.push(stealPom(x - 1 + oddy, y + 1, who))
  res.push(stealPom(x + oddy, y + 1, who))

  return res.filter((r) => r !== undefined)
}

export function tryJump (x, y, arr, kind) {
  const { jumpHash } = context
  return tryPom(
    x,
    y,
    arr,
    jumpHash,
    kind
  )
}

export function trySplit (x, y, arr, kind) {
  const { splitHash } = context
  return tryPom(
    x,
    y,
    arr,
    splitHash,
    kind
  )
}

export function tryAdd (canadd, value, arr) {
  if (canadd) {
    arr.push(value)
    return true
  }
  return false
}

export function tryPom (x, y, arr, hasharr, kind) {
  if (
    x > ROW_LENGTH - 1 ||
    x < 0 ||
    y > ROW_LENGTH - 1 ||
    y < 0
  ) {
    return
  }

  const board = context
  const g = board.poms

  const n = x + (y * ROW_LENGTH)

  if (tryAdd(
    g[n] === kind,
    n,
    arr
  )) {
    hasharr[n] = arr.length
  }
}

export function stealPom (x, y, who) {
  if (
    x > ROW_LENGTH - 1 ||
    x < 0 ||
    y > ROW_LENGTH - 1 ||
    y < 0
  ) {
    return
  }

  const board = context
  const g = board.poms

  const n = x + (y * ROW_LENGTH)
  const from = who === 1 ? 2 : 1

  if (g[n] === from) {
    g[n] = who
    return n
  }
}

export function findPoms (i, findOnly, kind = 0) {
  const board = context
  const poms = {}

  const n = i
  const x = n % ROW_LENGTH
  const y = Math.floor(n / ROW_LENGTH)

  let oddy = 0
  if (y % 2 === 1) {
    oddy = 1
  }

  let arr

  // split

  arr = []
  if (!findOnly) board.splitHash = {}

  trySplit(x - 1, y, arr, kind)
  trySplit(x + 1, y, arr, kind)

  trySplit(x - 1 + oddy, y - 1, arr, kind)
  trySplit(x + oddy, y - 1, arr, kind)

  trySplit(x - 1 + oddy, y + 1, arr, kind)
  trySplit(x + oddy, y + 1, arr, kind)

  poms.canSplitTo = arr
  if (!findOnly) board.canSplitTo = arr

  // jump

  arr = []
  if (!findOnly) board.jumpHash = {}

  tryJump(x - 2, y, arr, kind)
  tryJump(x + 2, y, arr, kind)

  tryJump(x - 1, y - 2, arr, kind)
  tryJump(x, y - 2, arr, kind)
  tryJump(x + 1, y - 2, arr, kind)

  tryJump(x - 1, y + 2, arr, kind)
  tryJump(x, y + 2, arr, kind)
  tryJump(x + 1, y + 2, arr, kind)

  tryJump(x - 2 + oddy, y - 1, arr, kind)
  tryJump(x + 1 + oddy, y - 1, arr, kind)
  tryJump(x - 2 + oddy, y + 1, arr, kind)
  tryJump(x + 1 + oddy, y + 1, arr, kind)

  poms.canJumpTo = arr
  if (!findOnly) board.canJumpTo = arr

  return poms
}

export function clearSelected () {
  const board = context
  board.selected = null
  board.canJumpTo = null
  board.canSplitTo = null
}

export function findPlayerPoms (player) {
  const board = context
  return board.poms
    .map((player, i) => ({ player, i }))
    .filter((pom) => pom.player === player)
    .map((pom) => pom.i)
}

export function findMoves (player, findOnly) {
  return findPlayerPoms(player).map(pom => {
    const poms = findPoms(pom, findOnly)
    return {
      pom,
      jumpTo: clone(poms.canJumpTo),
      splitTo: clone(poms.canSplitTo)
    }
  })
}

export function skipTurn () {
  const board = context

  board.selected = null
}

export function nextTurn () {
  const board = context

  let nextTurn = board.whoseTurn + 1
  if (nextTurn > board.numPlayers) nextTurn = 1

  board.whoseTurn = nextTurn
  board.selected = null
}

export function endGame () {
  const board = context

  const numPoms = findPlayerPoms(PLAYER_1).length
  const otherNumPoms = findPlayerPoms(PLAYER_2).length

  if (numPoms > otherNumPoms) {
    board.winner = PLAYER_1
  } else if (numPoms < otherNumPoms) {
    board.winner = PLAYER_2
  } else {
    board.winner = -1 // draw
  }

  if (window) alert(`Game over, player ${board.winner} wins.`)
}

export function countGains (i, who) {
  const board = context

  const n = i
  const x = n % ROW_LENGTH
  const y = Math.floor(n / ROW_LENGTH)

  let oddy = 0
  if (y % 2 === 1) {
    oddy = 1
  }

  const checkGain = (x, y) => {
    const pos = y * ROW_LENGTH + x
    return board.poms[pos] === who ? 1 : 0
  }

  let gains = 0

  gains += checkGain(x - 1, y)
  gains += checkGain(x + 1, y)

  gains += checkGain(x - 1 + oddy, y - 1)
  gains += checkGain(x + oddy, y - 1)

  gains += checkGain(x - 1 + oddy, y + 1)
  gains += checkGain(x + oddy, y + 1)

  return gains
}
